import moment from 'moment-timezone';
import logger from '../../../utils/logger';
import { Material } from '../../../../types/api/Material';
import { Device } from '../../../../types/api/Device';
import { ChangeMaterialMidBatchParams } from './types';
import { getScheduledRemaining } from './proportion-schedule';

export const logSubstitution = (
  batchStore: any,
  originalMaterial: Material,
  substituteMaterial: Material,
  originalBins: Device[],
  substituteBins: Device[],
  params: ChangeMaterialMidBatchParams,
  currentScaleWeight: number,
  deferredWeight: number,
  runningData: any,
  scaleData: any,
) => {
  const { originalMaterialId, substituteMaterialId, scaleId, reason, currentWeight = 0 } = params;
  // scaleData is the substitute entry, whose target already excludes what the original dispensed.
  // Includes a proportion two the substitute still feeds later.
  const remainingTarget = getScheduledRemaining(scaleData);
  const originalBinIds = originalBins.map(bin => bin.id);
  const substituteBinIds = substituteBins.map(bin => bin.id);

  batchStore.saveLog({
    level: 'info',
    message: `Material substituted: ${originalMaterial.code} -> ${substituteMaterial.code}, bins switched from ${originalBinIds.join(', ')} to ${substituteBinIds.join(', ')}`,
    data: {
      originalMaterialId,
      substituteMaterialId,
      scaleId,
      originalBinId: originalBinIds[0],
      newBinId: substituteBinIds[0],
      originalBinIds,
      newBinIds: substituteBinIds,
      reason,
      currentWeight,
      deferredWeight,
      batchId: runningData.uid,
      timestamp: moment().tz(batchStore.timezone).format(),
      currentScaleWeight,
      remainingTarget,
    },
  });

  batchStore.showSuccess(`Material substituted: ${originalMaterial.code} → ${substituteMaterial.code}, using bins ${substituteBinIds.join(', ')}. Remaining target: ${remainingTarget.toFixed(2)}`);
};

export const resumeBatchWithSubstitute = (batchStore: any, scaleId: string, runningData: any, substituteMaterial: Material) => {
  batchStore.setTimeout(() => {
    if (batchStore.isActiveDrop(runningData)) {
      logger.log('Starting batch with substitute material:', substituteMaterial.code);
      batchStore.batchDataForScale(Number(scaleId), runningData);
    }
  }, 500);
};
